<template>
  <div>
    <header-component/>
    <router-view></router-view>
  </div>
</template>
<script>
import HeaderComponent from '@/widgets/WebsiteHeader'
export default {
  components: {
    HeaderComponent
  }
}
</script>
